import { Link } from "react-router-dom";
import { ArrowRight, Cloud, Server } from "lucide-react";

const HOSTING = [
  { id: "hosted", Icon: Cloud, t: "Hosted for you", b: "Grace Treasury is hosted for your church, so there is nothing for you to install.", fee: "Hosting fee \u00b7 pricing to be announced" },
  { id: "self-hosted", Icon: Server, t: "Self-hosted", b: "Run Grace Treasury on a system your church controls. If you'd like help, the developer can install it for you, on-site or remotely.", fee: "Optional installation fee \u00b7 pricing to be announced" },
];

const HostingOptions = () => (
  <section className="border-t border-slate-200 py-16 sm:py-24" data-testid="pricing-hosting-section">
    <div className="container-x">
      <Reveal className="max-w-2xl">
        <p className="eyebrow">Hosting options</p>
        <h2 className="h2 mt-4">Hosted for you, or on your own system.</h2>
      </Reveal>
      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:gap-8">
        {HOSTING.map(({ id, Icon, t, b, fee }, i) => (
          <Reveal key={id} delay={i * 0.08} className="h-full">
            <div className="flex h-full flex-col border border-slate-200 p-8 sm:p-10" data-testid={`hosting-option-${id}`}>
              <Icon className="h-6 w-6 text-[#8a6a2f]" />
              <h3 className="mt-6 font-display text-3xl font-semibold text-navy">{t}</h3>
              <p className="mt-4 flex-1 text-base leading-relaxed text-slate-600">{b}</p>
              <p className="mt-8 border-t border-slate-200 pt-5 font-mono text-xs uppercase tracking-[0.16em] text-[#8a6a2f]">{fee}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
import { Reveal, LineReveal } from "@/components/site/motion";
import { WaitlistForm } from "@/components/site/WaitlistForm";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <section className="hairline-grid bg-parchment">
        <div className="container-x py-16 sm:py-24 lg:py-28">
          <span className="inline-flex items-center gap-2 border border-[#c5a059]/60 bg-white px-3 py-1.5 font-mono text-xs uppercase tracking-[0.2em] text-[#8a6a2f]" data-testid="pricing-status-badge">
            Launch pricing &middot; coming soon
          </span>
          <LineReveal lines={["Pricing is being", "finalised."]} className="mt-8 max-w-3xl font-display text-5xl font-semibold leading-[1.04] tracking-tight text-navy sm:text-6xl" />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg" data-testid="pricing-message">
              We're settling the details before launch, for both hosted and self-hosted churches. Join the waitlist to hear launch pricing first, or request a demo and see Grace Treasury in the meantime.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="py-16 sm:py-24">
        <div className="container-x grid gap-6 lg:grid-cols-12 lg:gap-8">
          <Reveal className="lg:col-span-7">
            <div id="waitlist" className="h-full bg-navy p-8 text-white sm:p-12" data-testid="pricing-waitlist-card">
              <p className="eyebrow-light">Waitlist</p>
              <h2 className="mt-4 font-display text-3xl font-semibold sm:text-4xl">Hear launch pricing first.</h2>
              <p className="mb-8 mt-4 max-w-md text-sm leading-relaxed text-slate-300">Leave your email and, if you like, your church's name. We'll write when pricing is published.</p>
              <WaitlistForm id="pricing-waitlist" dark source="pricing" />
            </div>
          </Reveal>
          <Reveal delay={0.08} className="lg:col-span-5">
            <div className="flex h-full flex-col justify-between border border-slate-200 p-8 sm:p-12" data-testid="pricing-demo-card">
              <div>
                <p className="eyebrow">Demo</p>
                <h2 className="mt-4 font-display text-3xl font-semibold text-navy sm:text-4xl">See it before you decide.</h2>
                <p className="mt-4 text-sm leading-relaxed text-slate-600">Tell us about your church and we'll arrange a walkthrough.</p>
              </div>
              <Link to="/demo" className="btn-primary group mt-10" data-testid="pricing-request-demo-button">
                Request a demo <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
      <HostingOptions />
    </div>
  );
}
